module.exports = __webpack_public_path__ + "static/What-to-Expect-During-the-Session-84d9dc1ba89ef91aeac474cf613f36e0.webp";